/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SimpleError = zod
	.object({
		error: zod.string()
	})
	.describe('Simple error message');

export type SimpleError = zod.input<typeof SimpleError>;
export type SimpleErrorOutput = zod.output<typeof SimpleError>;
